import React, { Component } from 'react'
import { connect } from 'react-redux'

import Alert from 'sweetalert-react'
import { Row, Col, Modal } from 'react-bootstrap'

import ClientContacts from 'src/content/Clients/Contacts/ClientContacts'

import {
  actionTypes as typesC,
  createClient,
  onCreateClientStep,
} from 'src/actions/clients.actions'
import {
  selectCreate,
  selectDeliverersToSelect,
  selectSellers,
  selectSingleClient,
} from 'src/selectors/clients.selector'

import { selectAllLocalitiesForSelect } from 'src/selectors/address.selector'

import { loadingSelector } from 'src/selectors/loading.selector'
import {
  hasErrorsSelector,
  singleErrorSelector,
  handlerSuccess,
  handlerError,
} from 'src/selectors/error.selector'

import CustomSelect from 'src/components/inputs/Select/CustomSelect'
import FormTextField from 'src/components/inputs/FormTextField/FormText'
import Card from 'src/components/cards/Card'
import Button from 'src/components/buttons/Button'
import ButtonIcon from 'src/components/buttons/IconButton'
import { faArrowLeft, faSave } from '@fortawesome/free-solid-svg-icons'
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes'
import { selectUsers, selectUsersToSelect } from 'src/selectors/modules.selector'
import { getUsersChildrenByModule } from 'src/actions/modules.actions'
import { selectCurrentModule } from 'src/selectors/user.selector'
import { FormText } from 'src/components'
import { createBrowserHistory } from 'history'
import CustomDatePicker from 'src/components/CustomDatePicker/CustomDatePicker'
import { identificationTypesEnum } from 'src/enums/identificationTypes'
import { Country } from 'src/enums/countries'
import { selectCompanyCountry } from 'src/selectors/company.selector'

import { fetchDynamicFieldsByEntityClients } from 'src/actions/dynamicfield.actions'
import { dynamicEntityType } from 'src/enums/dynamicFieldsEnum'
import { selectEntityFields } from 'src/selectors/dynamicFields.selector'

import { DynamicFieldInForm } from 'src/components/CompanyDynamicFields/presentations/DynamicFieldInForm'

export const history = createBrowserHistory()

class SpecificClient extends Component {
  state = {
    errors: {},
    alert: { title: 'text' },
    areas: [],
    clients: [],
    multi: false,
    modalC: false,
    email: null,
    emails: [],
    valid: true,
  }

  componentDidMount() {
    const { client, module } = this.props
    this.props.getUsers(module, true)
    if (client.town && client.town != '' && client.town.areas) {
      this.setState({
        areas: client.town.areas.map(a => {
          return { value: a.id, label: a.name }
        }),
      })
    } else {
      this.setState({ valid: false })
    }
  }

  UNSAFE_componentWillReceiveProps(next) {
    const { loading, hasError, handlerError, handlerSuccess, onlyCloseModal, setClient } =
      this.props
    const { error, response } = next
    let alert = { title: 'text' }

    if (loading && !next.loading) {
      if (!hasError && next.hasError) {
        alert = handlerError(
          error.response
            ? error.response.data.message
            : 'Ha ocurrido un error inesperado',
        )
        alert.onConfirm = () => this.setState({ alert: { ...alert, show: false } })
      } else {
        alert = handlerSuccess('Cliente creado satisfactoriamente')
        alert.onConfirm = () => {
          this.setState({ alert: { ...alert, show: false } })
          setClient({})

          if (onlyCloseModal) {
            onlyCloseModal(response)
          } else history.goBack()
        }
      }
      this.setState({ alert })
    }
  }

  onDateFromChange = date => {
    let { client, setClient } = this.props
    if (date) {
      setClient({ ...client, date: date })
    }
  }

  handleInputChange = event => {
    const { name, value } = event.target
    let { client, setClient } = this.props
    client[name] = value
    setClient(client)
  }

  handleCheckBoxChange = event => {
    const { name, checked } = event.target
    let { client, setClient } = this.props
    let { emails } = this.state

    this.setState({ [name]: checked })
    if (!checked)
      setClient({ ...client, email: client.email ? client.email.value : null })
    else if (client.email) {
      let array = [{ label: client.email, value: client.email }, ...emails]
      let newArray = array.map(item => {
        return [item.value, item]
      })
      var MapArr = new Map(newArray) // Pares de clave y valor
      let values = [...MapArr.values()]
      this.setState({ emails: [...values] })
      setClient({
        ...client,
        email: { label: client.email, value: client.email },
      })
    }
  }

  onSelectUser = selectedUser => {
    const { client, setClient } = this.props
    const { viewers = [] } = client

    viewers.push(selectedUser)
    setClient({ ...client, viewers })
  }

  deleteUser = id => {
    const { client, setClient } = this.props

    const viewers = client.viewers.filter(p => id !== p.value)
    setClient({ client, viewers })
  }

  render() {
    const { client, setClient, loading, users } = this.props
    const { errors, alert, modalC, email, emails } = this.state

    return (
      <div>
        <Card>
          <Row>
            <Col xl={4} lg={4} md={6} sm={12} xs={12}>
              <CustomDatePicker
                label={'Fecha de nacimiento'}
                value={client.date}
                onDayChange={this.onDateFromChange}
              />
            </Col>
            <Col xl={8} lg={8} md={6} sm={12} xs={12}>
              <FormTextField
                disabled={loading}
                label={'Referencia para entregas y delivery'}
                type={'text'}
                name={'reference'}
                placeholder={'Referencia para entregas y delivery'}
                value={client.reference}
                onChange={this.handleInputChange}
                error={errors?.reference}
              />
            </Col>
            <Col xl={4} lg={4} md={6} sm={12} xs={12}>
              <FormTextField
                disabled={loading}
                label={'Límite de Crédito'}
                type={'number'}
                id={'creditLimit'}
                placeholder={'Límite de credito'}
                name={'creditLimit'}
                value={client.creditLimit}
                onChange={({ target }) =>
                  setClient({
                    ...client,
                    creditLimit: !target.value || target.value < 0 ? 0 : target.value,
                  })
                }
              />
            </Col>

            <Col xl={4} lg={4} md={6} sm={12} xs={12}>
              <FormTextField
                disabled={loading}
                label={'Código de proveedor'}
                type={'text'}
                id={'codeProvider'}
                placeholder={'Añadir código de proveedor'}
                name={'codeProvider'}
                value={client.codeProvider}
                onChange={({ target }) =>
                  setClient({
                    ...client,
                    codeProvider: target.value,
                  })
                }
                sub={
                  'El valor indicado sera visible en ordenes de cotización, el código de proveedor corresponde al código dado al cliente como empresa proveedora'
                }
              />
            </Col>

            <Col xl={12} lg={12} md={12} sm={12} xs={12}>
              <CustomSelect
                label={'Usuarios visualizadores'}
                options={users.filter(s => {
                  return (
                    !client.viewers || client.viewers?.every(f => f.value !== s.value)
                  )
                })}
                error={errors?.attendant}
                onChange={this.onSelectUser}
              />
              {client.viewers?.length > 0 && (
                <Row className={'pl-1'} style={{ width: '100%' }}>
                  <br />
                  {client.viewers.map(p => (
                    <div key={p.value} className={'user-tag  ml-2 mt-2'}>
                      <label className={'label-user-tag'}>{p.label}</label>
                      <ButtonIcon
                        className={'delete-user-tag'}
                        icon={faTimes}
                        tooltip={'Quitar'}
                        color={'white'}
                        onClick={() => this.deleteUser(p.value)}
                      />
                    </div>
                  ))}
                </Row>
              )}
            </Col>

            <Col xl={12} lg={12} md={12} sm={12} xs={12}>
              <ClientContacts
                options={client.contacts}
                onChange={list => {
                  let { client, setClient } = this.props
                  client.contacts = list
                  setClient(client)
                }}
                show
              />
            </Col>
          </Row>
        </Card>

        <DynamicFieldInForm
          fields={this.props.dynamicFields}
          onUpdate={this.props.setFields}
          disabled={loading}
        />

        <hr />
        <Row className={'container-buttons'}>
          <Button
            disabled={loading}
            onClick={() => this.props.jumpToStep(0)}
            icon={faArrowLeft}>
            Atras
          </Button>
          <Button loading={loading} onClick={() => this.props.onValidate()} icon={faSave}>
            Guardar
          </Button>
        </Row>

        <Modal
          show={modalC}
          centered
          size={'md'}
          onHide={() => this.setState({ modalC: false })}>
          <Modal.Header closeButton>
            <Modal.Title>Nuevo correo electronico</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FormText
              value={email}
              type={'text'}
              label={'Correo electronico'}
              required
              onChange={({ target }) => {
                let { value } = target
                this.setState({ email: value })
              }}
            />
          </Modal.Body>
          <Modal.Footer>
            <Row className={'container-buttons'}>
              <Button
                disabled={!email}
                icon={faSave}
                color={'primary'}
                onClick={() => {
                  let item = { label: email, value: email }
                  if (emails.length === 0)
                    this.props.setClient({ ...this.props.client, email: item })
                  this.setState({
                    emails: [...emails, item],
                    modalC: false,
                    email: null,
                  })
                }}>
                Guardar
              </Button>
            </Row>
          </Modal.Footer>
        </Modal>

        <Alert {...alert} />
      </div>
    )
  }
}

const mapStateToProps = state => ({
  client: selectCreate(state),
  allClients: selectUsersToSelect(state),
  country: selectCompanyCountry(state),
  users: selectUsers(state),
  module: selectCurrentModule(state),
  localities: selectAllLocalitiesForSelect(state),
  entityFields: selectEntityFields(state),
  deliverers: selectDeliverersToSelect(state),
  sellers: selectSellers(state),
  loading: loadingSelector([typesC.CREATE_SINGLE_CLIENTS])(state),
  hasError: hasErrorsSelector([typesC.CREATE_SINGLE_CLIENTS])(state),
  error: singleErrorSelector([typesC.CREATE_SINGLE_CLIENTS])(state),
  handlerError: message => handlerError(message),
  handlerSuccess: message => handlerSuccess(message),
  response: selectSingleClient(state),
})
const mapDispatchToProps = dispatch => ({
  setClient: client => dispatch(onCreateClientStep(client)),
  getDynamicFields: () => dispatch(fetchDynamicFieldsByEntityClients()),
  createClient: (client, images, categorization) =>
    dispatch(createClient(client, images, categorization)),
  getUsers: (module, includeParent) =>
    dispatch(getUsersChildrenByModule(module, includeParent)),
})
export default connect(mapStateToProps, mapDispatchToProps)(SpecificClient)
